// 不同国家对应的不同类型

// 财务期间类型
export const financialPeriodTypeData = {
  Singapore: [
    {
      value: "12 months",
      zh: "12 months[12个月]",
      en: "12 months",
    },
    {
      value: "52-week accounting period",
      zh: "52-week accounting period[52周]",
      en: "52-week accounting period",
    },
  ],
  Malaysia: [
    {
      value: "12 months",
      zh: "12 months[12个月]",
      en: "12 months",
    },
  ],
};

// 实体类型
export const entityTypeData = {
  Malaysia: [
    {
      value: 1,
      zh: "Local Entity 本地实体",
      en: "Local Entity",
    },
    {
      value: 2,
      zh: "Foreign Entity 外国实体",
      en: "Foreign Entity",
    },
  ],
};

// 公司类型
export const companyTypeData = {
  Malaysia: [
    {
      value: "Bodies corporate controlled by citizens who are Malays and natives",
      zh: "Bodies corporate controlled by citizens who are Malays and natives 由马来人和原住民公民控制的法人团体",
      en: "Bodies corporate controlled by citizens who are Malays and natives",
    },
    {
      value: "Bodies corporate controlled by citizens who are non-Malays and non-natives",
      zh: "Bodies corporate controlled by citizens who are non-Malays and non-natives 由非马来人和非本地人公民控制的法人团体",
      en: "Bodies corporate controlled by citizens who are non-Malays and non-natives",
    },
    {
      value: "Bodies corporate controlled by non-citizens",
      zh: "Bodies corporate controlled by non-citizens 非公民控制的法人团体",
      en: "Bodies corporate controlled by non-citizens",
    },
  ],
};

// 种族类型
export const raceTypeData = {
  Malaysia: [
    {
      value: "BAJAU",
      zh: "BAJAU 文纳人",
      en: "BAJAU",
    },
    {
      value: "BIDAYUH",
      zh: "BIDAYUH 非文纳人",
      en: "BIDAYUH",
    },
    {
      value: "BUMIPUTERA SABAH",
      zh: "BUMIPUTERA SABAH 拿巴莱土著",
      en: "BUMIPUTERA SABAH",
    },
    {
      value: "BUMIPUTERA SARAWAK",
      zh: "BUMIPUTERA SARAWAK 拿拉瓦土著",
      en: "BUMIPUTERA SARAWAK",
    },
    {
      value: "CHINESE",
      zh: "CHINESE 中国人",
      en: "CHINESE",
    },
    {
      value: "DUSUN",
      zh: "DUSUN 东孙人",
      en: "DUSUN",
    },
    {
      value: "FOREIGNER",
      zh: "FOREIGNER 外国人",
      en: "FOREIGNER",
    },
    {
      value: "IBAN",
      zh: "IBAN 印度尼西亚人",
      en: "IBAN",
    },
    {
      value: "INDIAN",
      zh: "INDIAN 印度人",
      en: "INDIAN",
    },
    {
      value: "KADAZAN",
      zh: "KADAZAN 卡达赞人",
      en: "KADAZAN",
    },
    {
      value: "MALAY",
      zh: "MALAY 马来人",
      en: "MALAY",
    },
    {
      value: "MELANAU",
      zh: "MELANAU 文纳人",
      en: "MELANAU",
    },
    {
      value: "NATIVE",
      zh: "NATIVE 本地人",
      en: "NATIVE",
    },
    {
      value: "ORANG ULU",
      zh: "ORANG ULU 原住民",
      en: "ORANG ULU",
    },
    {
      value: "OTHER RACE",
      zh: "OTHER RACE 其他种族",
      en: "OTHER RACE",
    },
  ],
};
